import { createContext, useContext, useState } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("bg_lang") || "en");
  const setLang = (l) => { localStorage.setItem("bg_lang", l); setLangState(l); };
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);

export function pick(article, field, lang) {
  if (lang === "hi" && article?.[`${field}_hi`]) return article[`${field}_hi`];
  return article?.[field];
}
